import React, { useState } from 'react';
import { Download, Search, X, ShoppingCart } from 'lucide-react';

// Sample products from your order sheet
const products = [
  { id: '59294', name: 'PEPSI', size: '7.5Z 6PK', code: '59294', category: 'Pepsi Products' },
  { id: '59295', name: 'DT PEPSI', size: '7.5Z 6PK', code: '59295', category: 'Pepsi Products' },
  { id: '59296', name: 'MT DEW', size: '7.5Z 6PK', code: '59296', category: 'Mountain Dew' },
  { id: '59297', name: 'GINGER ALE', size: '7.5Z 6PK', code: '59297', category: 'Schweppes' },
  { id: '59298', name: 'DT GINGER ALE', size: '7.5Z 6PK', code: '59298', category: 'Schweppes' },
  { id: '59299', name: 'CRUSH ORANGE', size: '7.5Z 6PK', code: '59299', category: 'Crush' },
  { id: '59622', name: 'PEPSI ZERO', size: '7.5Z 6PK', code: '59622', category: 'Pepsi Products' },
  { id: '60340', name: 'TONIC', size: '7.5Z 6PK', code: '60340', category: 'Schweppes' },
  { id: '60341', name: 'CLUB SODA', size: '7.5Z 6PK', code: '60341', category: 'Schweppes' },
  { id: '59691', name: 'SCH GIN/ALE', size: '7.5Z 3/10PK', code: '59691', category: 'Schweppes' },
  { id: '59593', name: 'PEPSI', size: '7.5Z 3/10PK', code: '59593', category: 'Pepsi Products' },
  { id: '59594', name: 'DT PEPSI', size: '7.5Z 3/10PK', code: '59594', category: 'Pepsi Products' },
  { id: '59595', name: 'MT DEW', size: '7.5Z 3/10PK', code: '59595', category: 'Mountain Dew' },
  
  // 8.5Z GLASS
  { id: '58529', name: 'PEPSI', size: '8.5Z 24PK', code: '58529', category: 'Pepsi Products' },
  { id: '58530', name: 'DT PEPSI', size: '8.5Z 24PK', code: '58530', category: 'Pepsi Products' },
  { id: '60819', name: 'SIERRA MIST', size: '8.5Z 24PK', code: '60819', category: 'Sierra Mist' },
  
  // 10Z GLASS
  { id: '13779', name: 'PEPSI', size: '10Z 6PK', code: '13779', category: 'Pepsi Products' },
  { id: '13780', name: 'DT PEPSI', size: '10Z 6PK', code: '13780', category: 'Pepsi Products' },
  { id: '13781', name: 'SCH GINGER ALE', size: '10Z 6PK', code: '13781', category: 'Schweppes' },
  { id: '13782', name: 'SCH TONIC', size: '10Z 6PK', code: '13782', category: 'Schweppes' },
  { id: '13783', name: 'SCH CLUB SODA', size: '10Z 6PK', code: '13783', category: 'Schweppes' },
  
  // 12Z 8PK
  { id: '55112', name: 'MT DEW', size: '12Z 8PK', code: '55112', category: 'Mountain Dew' },
  { id: '55109', name: 'PEPSI', size: '12Z 8PK', code: '55109', category: 'Pepsi Products' },
  { id: '55110', name: 'DT PEPSI', size: '12Z 8PK', code: '55110', category: 'Pepsi Products' },
  { id: '58199', name: 'GINGER ALE', size: '12Z 8PK', code: '58199', category: 'Schweppes' },
  { id: '60848', name: 'CHERRY PEPSI', size: '12Z 8PK', code: '60848', category: 'Pepsi Products' },
  
  // 12Z GLASS/CANS
  { id: '56967', name: 'PEPSI MEXICO', size: '12Z 24PK', code: '56967', category: 'Pepsi Products' },
  { id: '58438', name: 'SCH GINGER', size: '12Z 24PK', code: '58438', category: 'Schweppes' },
  { id: '14282', name: 'PEPSI SLAB', size: '12Z 24PK', code: '14282', category: 'Pepsi Products' },
  
  // STARBUCKS
  { id: '55052', name: 'STARBUCKS DOUBLE SHOT COFFEE', size: '15.5Z 12PK', code: '55052', category: 'Starbucks' },
  { id: '55053', name: 'STARBUCKS DOUBLE SHOT MOCHA', size: '15.5Z 12PK', code: '55053', category: 'Starbucks' },
  { id: '55054', name: 'STARBUCKS DOUBLE SHOT VANILLA', size: '15.5Z 12PK', code: '55054', category: 'Starbucks' },
  { id: '13903', name: 'STARBUCKS DOUBLE SHOT', size: '6.5Z 12PK', code: '13903', category: 'Starbucks' },
  { id: '15317', name: 'STARBUCKS DOUBLE SHOT', size: '6.5Z 4PK', code: '15317', category: 'Starbucks' },
  { id: '14707', name: 'FRAPP COFFEE', size: '9.5Z 6/4PK', code: '14707', category: 'Starbucks' },
  { id: '14706', name: 'FRAPP VANILLA', size: '9.5Z 6/4PK', code: '14706', category: 'Starbucks' },
  { id: '14705', name: 'FRAPP MOCHA', size: '9.5Z 6/4PK', code: '14705', category: 'Starbucks' },
  { id: '57587', name: 'FRAP MOCHA', size: '13.7Z 12PK', code: '57587', category: 'Starbucks' },
  { id: '15450', name: 'FRAP COFFEE', size: '13.7Z 12PK', code: '15450', category: 'Starbucks' },
  { id: '57939', name: 'FRAP CARAMEL', size: '13.7Z 12PK', code: '57939', category: 'Starbucks' },
  { id: '57588', name: 'FRAP VANILLA', size: '13.7Z 12PK', code: '57588', category: 'Starbucks' },
  { id: '58912', name: 'FRAP COFFEE', size: '9.5Z 15PK', code: '58912', category: 'Starbucks' },
  { id: '58911', name: 'FRAP VANILLA', size: '9.5Z 15PK', code: '58911', category: 'Starbucks' },
  { id: '58914', name: 'FRAP MOCHA', size: '9.5Z 15PK', code: '58914', category: 'Starbucks' },
  { id: '59157', name: 'STBK CB UNSWEET', size: '11Z 12PK', code: '59157', category: 'Starbucks' },
  { id: '59801', name: 'STBK TS CARAMEL', size: '15Z 12PK', code: '59801', category: 'Starbucks' },
  { id: '59802', name: 'STBK TS VANILLA', size: '15Z 12PK', code: '59802', category: 'Starbucks' },
  { id: '60296', name: 'STBK NITRO BLACK', size: '9.6Z 12PK', code: '60296', category: 'Starbucks' },
  { id: '60297', name: 'STBK NITRO VAN', size: '9.6Z 12PK', code: '60297', category: 'Starbucks' },
  { id: '60298', name: 'STBK NITRO CARAMEL', size: '9.6Z 12PK', code: '60298', category: 'Starbucks' },
  { id: '60580', name: 'STBK NITRO DK COCOA', size: '9.6Z 12PK', code: '60580', category: 'Starbucks' },
  { id: '60698', name: 'STBK CC SWT BLACK', size: '11Z 12PK', code: '60698', category: 'Starbucks' },
  { id: '60188', name: 'STBK CARMEL MACH', size: '14Z 12PK', code: '60188', category: 'Starbucks' },
  { id: '60971', name: 'STBK BAYA MAN GUA', size: '12Z 12PK', code: '60971', category: 'Starbucks' },
  { id: '60972', name: 'STBK BAYA PA PASS', size: '12Z 12PK', code: '60972', category: 'Starbucks' },
  { id: '60973', name: 'STBK BAYA RAS LIM', size: '12Z 12PK', code: '60973', category: 'Starbucks' },
  { id: '61100', name: 'PEPSI NITRO COLA', size: '13.65Z 12PK', code: '61100', category: 'Pepsi Products' },
  { id: '61101', name: 'PEPSI NITRO VAN', size: '13.65Z 12PK', code: '61101', category: 'Pepsi Products' },
  { id: '61043', name: 'PEPSI NITRO COLA', size: '13.65Z 6/4P', code: '61043', category: 'Pepsi Products' },
  { id: '61044', name: 'PEPSI NITRO VAN', size: '13.65Z 6/4P', code: '61044', category: 'Pepsi Products' },
  
  // 16Z CANS
  { id: '58758', name: 'PEPSI', size: '16Z 12PK', code: '58758', category: 'Pepsi Products' },
  { id: '57424', name: 'PEPSI', size: '16Z 24PK', code: '57424', category: 'Pepsi Products' },
  { id: '57426', name: 'MT DEW', size: '16Z 24PK', code: '57426', category: 'Mountain Dew' },
  { id: '57429', name: 'SCH G/ALE', size: '16Z 24PK', code: '57429', category: 'Schweppes' },
  
  // 20Z 24PK - PEPSI FAMILY
  { id: '14188', name: 'PEPSI', size: '20Z 24PK', code: '14188', category: 'Pepsi Products' },
  { id: '14189', name: 'DT PEPSI', size: '20Z 24PK', code: '14189', category: 'Pepsi Products' },
  { id: '56858', name: 'PEPSI ZERO', size: '20Z 24PK', code: '56858', category: 'Pepsi Products' },
  { id: '14194', name: 'CHERRY PEPSI', size: '20Z 24PK', code: '14194', category: 'Pepsi Products' },
  { id: '56849', name: 'DT CHERRY PEPSI', size: '20Z 24PK', code: '56849', category: 'Pepsi Products' },
  { id: '59706', name: 'PEPSI VANILLA', size: '20Z 24PK', code: '59706', category: 'Pepsi Products' },
  { id: '60673', name: 'PEPSI MANGO', size: '20Z 24PK', code: '60673', category: 'Pepsi Products' },
  { id: '60677', name: 'PEPSI ZERO MANGO', size: '20Z 24PK', code: '60677', category: 'Pepsi Products' },
  
  // 20Z 24PK - MOUNTAIN DEW
  { id: '14197', name: 'MT DEW', size: '20Z 24PK', code: '14197', category: 'Mountain Dew' },
  { id: '14198', name: 'DT MTN DEW', size: '20Z 24PK', code: '14198', category: 'Mountain Dew' },
  { id: '14199', name: 'MT DEW RED', size: '20Z 24PK', code: '14199', category: 'Mountain Dew' },
  { id: '56855', name: 'MT DEW VOLTAGE', size: '20Z 24PK', code: '56855', category: 'Mountain Dew' },
  { id: '60227', name: 'MT DEW ZERO', size: '20Z 24PK', code: '60227', category: 'Mountain Dew' },
  { id: '60560', name: 'MTD MAJOR MELON', size: '20Z 24PK', code: '60560', category: 'Mountain Dew' },
  { id: '60561', name: 'MTD ZERO MELON', size: '20Z 24PK', code: '60561', category: 'Mountain Dew' },
  { id: '60917', name: 'MTD SPARK', size: '20Z 24PK', code: '60917', category: 'Mountain Dew' },
  { id: '60918', name: 'MTD SPARK ZERO', size: '20Z 24PK', code: '60918', category: 'Mountain Dew' },
  { id: '61052', name: 'MTD FLAMIN HOT CITRUS', size: '20Z 24PK', code: '61052', category: 'Mountain Dew' },
  { id: '61108', name: 'MTD BAJA MANGO', size: '20Z 24PK', code: '61108', category: 'Mountain Dew' },
  
  // 20Z 24PK - OTHER SODAS
  { id: '14201', name: 'MUG ROOT BEER', size: '20Z 24PK', code: '14201', category: 'Mug' },
  { id: '14205', name: 'SCH GINGER ALE', size: '20Z 24PK', code: '14205', category: 'Schweppes' },
  { id: '14206', name: 'SCH SELTZER', size: '20Z 24PK', code: '14206', category: 'Schweppes' },
  { id: '59970', name: 'SCH RASP GINGER', size: '20Z 24PK', code: '59970', category: 'Schweppes' },
  { id: '56160', name: 'SCH DT GINGER', size: '20Z 24PK', code: '56160', category: 'Schweppes' },
  { id: '59971', name: 'SCH DRY GRAPE', size: '20Z 24PK', code: '59971', category: 'Schweppes' },
  { id: '59983', name: 'SCH BLK.CHERRY G/ALE', size: '20Z 24PK', code: '59983', category: 'Schweppes' },
  { id: '60466', name: 'SCH CRAN RASP GIN', size: '20Z 24PK', code: '60466', category: 'Schweppes' },
  { id: '60727', name: 'SCH WHT PCH GINGER', size: '20Z 24PK', code: '60727', category: 'Schweppes' },
  { id: '15622', name: 'SCH CHERRY SELT', size: '20Z 24PK', code: '15622', category: 'Schweppes' },
  { id: '14698', name: 'SCH LEM LIM SELT', size: '20Z 24PK', code: '14698', category: 'Schweppes' },
  { id: '16217', name: 'SCH ORANGE SELT', size: '20Z 24PK', code: '16217', category: 'Schweppes' },
  { id: '57932', name: 'SCH RASP LIME SEL', size: '20Z 24PK', code: '57932', category: 'Schweppes' },
  { id: '58584', name: 'SCH CRN LIM SELT', size: '20Z 24PK', code: '58584', category: 'Schweppes' },
  { id: '58364', name: 'SCH POM SELT', size: '20Z 24PK', code: '58364', category: 'Schweppes' },
  { id: '59263', name: 'SCH GRPFRT SELT', size: '20Z 24PK', code: '59263', category: 'Schweppes' },
  { id: '59578', name: 'SCH STRAW MANGO', size: '20Z 24PK', code: '59578', category: 'Schweppes' },
  { id: '58766', name: 'SIERRA MIST RS', size: '20Z 24PK', code: '58766', category: 'Sierra Mist' },
  { id: '56848', name: 'CRUSH ORANGE', size: '20Z 24PK', code: '56848', category: 'Crush' },
  { id: '55514', name: 'CRUSH PINEAPPLE', size: '20Z 24PK', code: '55514', category: 'Crush' },
  { id: '57821', name: 'CRUSH GRAPE', size: '20Z 24PK', code: '57821', category: 'Crush' },
  { id: '60826', name: 'CRUSH FRT PUNCH', size: '20Z 24PK', code: '60826', category: 'Crush' },
  { id: '60638', name: 'MANZANITA SOLE', size: '20Z 24PK', code: '60638', category: 'Other' },
  
  // 20Z 24PK - DR BROWNS & SPECIALTY
  { id: '14226', name: 'DR BROWN BLACK CHERRY', size: '20Z 24PK', code: '14226', category: 'Dr Browns' },
  { id: '60016', name: 'DB CREAM', size: '20Z 24PK', code: '60016', category: 'Dr Browns' },
  
  // 20Z 24PK - TEAS & LEMONADES
  { id: '14214', name: 'LIPT BRISK', size: '20Z 24PK', code: '14214', category: 'Lipton' },
  { id: '14215', name: 'LIPT BRISK LEMADE', size: '20Z 24PK', code: '14215', category: 'Lipton' },
  { id: '15588', name: 'LIPT GREEN TEA', size: '20Z 24PK', code: '15588', category: 'Lipton' },
  { id: '58047', name: 'LTN ICE TEA PEACH', size: '20Z 24PK', code: '58047', category: 'Lipton' },
  { id: '60005', name: 'CT LEMONADE', size: '20Z 24PK', code: '60005', category: 'Country Time' },
  { id: '60006', name: 'CT STRW LMNDE', size: '20Z 24PK', code: '60006', category: 'Country Time' },
  { id: '60333', name: 'DOLE LEMONADE', size: '20Z 24PK', code: '60333', category: 'Dole' },
  { id: '60967', name: 'DOLE TROP LEMONADE', size: '20Z 24PK', code: '60967', category: 'Dole' },
  { id: '60964', name: 'DOLE STRAW LEMONADE', size: '20Z 24PK', code: '60964', category: 'Dole' },
  { id: '60829', name: 'JUCY FRT PUNCH', size: '20Z 24PK', code: '60829', category: 'Other' },
  
  // GATORADE 20Z
  { id: '11160', name: 'GATORADE ORANGE', size: '20Z 24PK', code: '11160', category: 'Gatorade' },
  { id: '11161', name: 'GATORADE FRUIT PUNCH', size: '20Z 24PK', code: '11161', category: 'Gatorade' },
  { id: '11159', name: 'GATORADE LEMON LIME', size: '20Z 24PK', code: '11159', category: 'Gatorade' },
  { id: '11163', name: 'GATORADE COOL BLUE', size: '20Z 24PK', code: '11163', category: 'Gatorade' },
  { id: '12766', name: 'GATORADE FIERCE GRAPE', size: '20Z 24PK', code: '12766', category: 'Gatorade' },
  { id: '13002', name: 'GAT GLACIER FREEZE', size: '20Z 24PK', code: '13002', category: 'Gatorade' },
  { id: '58674', name: 'GAT GLAC.CHERRY', size: '20Z 24PK', code: '58674', category: 'Gatorade' },
  { id: '59762', name: 'GAT ZERO GLAC CHERRY', size: '20Z 24PK', code: '59762', category: 'Gatorade' },
  { id: '59763', name: 'GAT ZERO GLAC FREEZE', size: '20Z 24PK', code: '59763', category: 'Gatorade' },
  { id: '59470', name: 'GAT G2 COOL BLUE', size: '20Z 24PK', code: '59470', category: 'Gatorade' },
  { id: '60360', name: 'GAT.GLAC FRZ', size: '12Z 6/4PK', code: '60360', category: 'Gatorade' },
  { id: '60361', name: 'GAT.BERRY', size: '12Z 6/4PK', code: '60361', category: 'Gatorade' },
  { id: '60362', name: 'GAT.ORANGE', size: '12Z 6/4PK', code: '60362', category: 'Gatorade' },
  
  // GATORADE 28Z
  { id: '58672', name: 'GAT LIME CUCUMBER', size: '28Z 15PK', code: '58672', category: 'Gatorade' },
  { id: '58333', name: 'GAT GLACIER CHERRY', size: '28Z 15PK', code: '58333', category: 'Gatorade' },
  { id: '58334', name: 'GAT GRAPE', size: '28Z 15PK', code: '58334', category: 'Gatorade' },
  { id: '58335', name: 'GAT COOL BLUE', size: '28Z 15PK', code: '58335', category: 'Gatorade' },
  { id: '58336', name: 'GAT GLACIER FREEZE', size: '28Z 15PK', code: '58336', category: 'Gatorade' },
  { id: '58337', name: 'GAT LEMON LIME', size: '28Z 15PK', code: '58337', category: 'Gatorade' },
  { id: '58338', name: 'GAT FRUIT PUNCH', size: '28Z 15PK', code: '58338', category: 'Gatorade' },
  { id: '58339', name: 'GAT ORANGE', size: '28Z 15PK', code: '58339', category: 'Gatorade' },
  { id: '58748', name: 'GAT FROST ARTIC BLITZ', size: '28Z 15PK', code: '58748', category: 'Gatorade' },
  { id: '58749', name: 'GAT FROST ICY CHARGE', size: '28Z 15PK', code: '58749', category: 'Gatorade' },
  { id: '59653', name: 'GAT.ZERO ORANGE', size: '28Z 15PK', code: '59653', category: 'Gatorade' },
  { id: '59654', name: 'GAT ZERO LEMON LIME', size: '28Z 15PK', code: '59654', category: 'Gatorade' },
  { id: '59657', name: 'GAT ZERO GLA CHERRY', size: '28Z 15PK', code: '59657', category: 'Gatorade' },
  { id: '59764', name: 'GAT ZERO BERRY', size: '28Z 15PK', code: '59764', category: 'Gatorade' },
  { id: '59765', name: 'GAT ZERO GLA FREEZE', size: '28Z 15PK', code: '59765', category: 'Gatorade' },
  { id: '60614', name: 'GAT ZERO COOL BLUE', size: '28Z 15PK', code: '60614', category: 'Gatorade' },
  { id: '60596', name: 'GAT CITRUS SWISH', size: '28Z 15PK', code: '60596', category: 'Gatorade' },
  { id: '61051', name: 'GAT ZERO LIME CUCUM', size: '28Z 15PK', code: '61051', category: 'Gatorade' },
  { id: '61056', name: 'GAT FIT TROP MANGO', size: '28Z 15PK', code: '61056', category: 'Gatorade' },
  { id: '61057', name: 'GAT FIT CITRUS BERRY', size: '28Z 15PK', code: '61057', category: 'Gatorade' },
  { id: '61058', name: 'GAT FIT WTRMLN STBRY', size: '28Z 15PK', code: '61058', category: 'Gatorade' },
  { id: '61059', name: 'GAT FIT CHERRY LIME', size: '28Z 15PK', code: '61059', category: 'Gatorade' },
  
  // GATORADE 24Z & 64Z
  { id: '56216', name: 'GAT COOL BLUE', size: '24Z 24PK', code: '56216', category: 'Gatorade' },
  { id: '56215', name: 'GAT FRUIT PUNCH', size: '24Z 24PK', code: '56215', category: 'Gatorade' },
  { id: '56460', name: 'GAT ORANGE', size: '64Z 8PK', code: '56460', category: 'Gatorade' },
  { id: '56458', name: 'GAT FRUIT PUNCH', size: '64Z 8PK', code: '56458', category: 'Gatorade' },
  
  // GATORLYTE
  { id: '60597', name: 'GTRLYTE STRAW KIWI', size: '20Z 12PK', code: '60597', category: 'Gatorade' },
  { id: '60598', name: 'GTRLYTE ORANGE', size: '20Z 12PK', code: '60598', category: 'Gatorade' },
  { id: '61060', name: 'GTRLYTE CHY LIME', size: '20Z 12PK', code: '61060', category: 'Gatorade' },
  { id: '61061', name: 'GTRLYTE WATERMELON', size: '20Z 12PK', code: '61061', category: 'Gatorade' },
  
  // GATORADE PROTEIN
  { id: '60599', name: 'GAT PRO FRT PUNCH', size: '16.9Z 12PK', code: '60599', category: 'Gatorade' },
  { id: '60600', name: 'GAT PRO COOL BLUE', size: '16.9Z 12PK', code: '60600', category: 'Gatorade' },
  
  // OCEAN SPRAY
  { id: '10728', name: 'OCEAN SPRAY CRANGRAPE', size: '15.2Z 12PK', code: '10728', category: 'Ocean Spray' },
  { id: '10725', name: 'OCEAN SPRAY CRANBERRY', size: '15.2Z 12PK', code: '10725', category: 'Ocean Spray' },
  
  // AQUAFINA WATER
  { id: '12653', name: 'AQUAFINA WATER', size: '16.9Z 24PK', code: '12653', category: 'Water' },
  { id: '11004', name: 'AQUAFINA WATER', size: '1LTR 15PK', code: '11004', category: 'Water' },
  { id: '11006', name: 'AQUAFINA WATER', size: '20Z 24PK', code: '11006', category: 'Water' },
  { id: '13771', name: 'AQUAFINA', size: '.5 LTR 6PK', code: '13771', category: 'Water' },
  { id: '16587', name: 'AQUAFINA WATER', size: '16.9Z 32PK', code: '16587', category: 'Water' },
  { id: '55756', name: 'AQUAFINA', size: '12Z 8PK', code: '55756', category: 'Water' },
  { id: '60946', name: 'AQUAFINA ALUMITEK', size: '16Z 24PK', code: '60946', category: 'Water' },
  
  // EVIAN WATER
  { id: '13770', name: 'EVIAN', size: '.5 LTR 6PK', code: '13770', category: 'Water' },
  { id: '14124', name: 'EVIAN', size: '1LTR 6PK', code: '14124', category: 'Water' },
  { id: '13776', name: 'EVIAN', size: '1.5LTR 12PK', code: '13776', category: 'Water' },
  { id: '14097', name: 'EVIAN', size: '1LTR 12PK', code: '14097', category: 'Water' },
  { id: '13747', name: 'EVIAN', size: '.5LTR 24PK', code: '13747', category: 'Water' },
  { id: '13803', name: 'EVIAN', size: '11.2Z 6PK', code: '13803', category: 'Water' },
  { id: '55491', name: 'EVIAN SPORT', size: '750ML 12PK', code: '55491', category: 'Water' },
  { id: '55572', name: 'EVIAN', size: '750ML 12PK', code: '55572', category: 'Water' },
  { id: '55557', name: 'EVIAN', size: '330ML 20PK', code: '55557', category: 'Water' },
  { id: '59247', name: 'EVIAN', size: '1.25L 2/4PK', code: '59247', category: 'Water' },
  { id: '60330', name: 'EV FERRARELLE', size: '330ML 24PK', code: '60330', category: 'Water' },
  { id: '60331', name: 'EV FERRARELLE', size: '750ML 12PK', code: '60331', category: 'Water' },
  { id: '60646', name: 'EVIAN', size: '1.5LTR 2/6PK', code: '60646', category: 'Water' },
  { id: '60647', name: 'EV RASP GINSG', size: '11.2Z 6PK', code: '60647', category: 'Water' },
  { id: '60648', name: 'EV GRPF BASIL', size: '11.2Z 6PK', code: '60648', category: 'Water' },
  { id: '60649', name: 'EV LIME GINGER', size: '11.2Z 6PK', code: '60649', category: 'Water' },
  { id: '60650', name: 'EV CUCUM MINT', size: '11.2Z 6PK', code: '60650', category: 'Water' },
  
  // ZEN WATER
  { id: '60601', name: 'ZEN WATER', size: '700ML 12PK', code: '60601', category: 'Water' },
  { id: '60602', name: 'ZEN WATER', size: '16.9Z 12PK', code: '60602', category: 'Water' },
  { id: '60604', name: 'ZEN WATER', size: '1LTR 12PK', code: '60604', category: 'Water' },
  { id: '60605', name: 'ZEN WATER', size: '1.5LTR 12PK', code: '60605', category: 'Water' },
  
  // FLOW WATER
  { id: '60899', name: 'FLOW ORIGINAL', size: '1LTR 12PK', code: '60899', category: 'Water' },
  { id: '60900', name: 'FLOW ORIGINAL', size: '500ML 6PK', code: '60900', category: 'Water' },
  { id: '60901', name: 'FLOW ORIGINAL', size: '500ML 12PK', code: '60901', category: 'Water' },
  { id: '60902', name: 'FLOW LEMON/GIN', size: '500ML 12PK', code: '60902', category: 'Water' },
  { id: '60903', name: 'FLOW CUCUMBER MINT', size: '500ML 12PK', code: '60903', category: 'Water' },
  { id: '60904', name: 'FLOW BLKBR HIBISCUS', size: '500ML 12PK', code: '60904', category: 'Water' },
  { id: '60905', name: 'FLOW STRAW.ROSE', size: '500ML 12PK', code: '60905', category: 'Water' },
  
  // 2 LITER PRODUCTS
  { id: '14294', name: 'PEPSI', size: '2LTR 6PK', code: '14294', category: 'Pepsi Products' },
  { id: '14296', name: 'DT PEPSI', size: '2LTR 6PK', code: '14296', category: 'Pepsi Products' },
  { id: '14298', name: 'CAF FREE PEPSI', size: '2LTR 6PK', code: '14298', category: 'Pepsi Products' },
  { id: '14300', name: 'DT CAF FREE PEPSI', size: '2LTR 6PK', code: '14300', category: 'Pepsi Products' },
  { id: '14302', name: 'CHERRY PEPSI', size: '2LTR 6PK', code: '14302', category: 'Pepsi Products' },
  { id: '14303', name: 'DT CHERRY PEPSI', size: '2LTR 6PK', code: '14303', category: 'Pepsi Products' },
  { id: '14308', name: 'MT DEW', size: '2LTR 6PK', code: '14308', category: 'Mountain Dew' },
  { id: '14309', name: 'DT MT DEW', size: '2LTR 6PK', code: '14309', category: 'Mountain Dew' },
  { id: '59586', name: 'PEPSI ZERO CHERRY', size: '2LTR 6PK', code: '59586', category: 'Pepsi Products' },
  { id: '14311', name: 'MUG ROOT BEER', size: '2LTR 6PK', code: '14311', category: 'Mug' },
  { id: '14312', name: 'DT MUG ROOT BEER', size: '2LTR 6PK', code: '14312', category: 'Mug' },
  { id: '14313', name: 'MUG CREAM', size: '2LTR 6PK', code: '14313', category: 'Mug' },
  { id: '14314', name: 'DT MUG CREAM', size: '2LTR 6PK', code: '14314', category: 'Mug' },
  { id: '14317', name: 'SCH GINGER ALE', size: '2LTR 6PK', code: '14317', category: 'Schweppes' },
  { id: '14318', name: 'DT SCH GINGER ALE', size: '2LTR 6PK', code: '14318', category: 'Schweppes' },
  { id: '14320', name: 'SCH RASP GINGER', size: '2LTR 6PK', code: '14320', category: 'Schweppes' },
  { id: '14321', name: 'SCH DRY GRAPE', size: '2LTR 6PK', code: '14321', category: 'Schweppes' },
  { id: '14319', name: 'SCH SELTZER', size: '2LTR 6PK', code: '14319', category: 'Schweppes' },
  { id: '16691', name: 'PEPSI ZERO', size: '2LTR 6PK', code: '16691', category: 'Pepsi Products' },
  { id: '16125', name: 'SCH LEM LIM SELT', size: '2LTR 6PK', code: '16125', category: 'Schweppes' },
  { id: '58365', name: 'SCH POM SELT', size: '2LTR 6PK', code: '58365', category: 'Schweppes' },
  { id: '14332', name: 'LIPT BRISK', size: '2LTR 6PK', code: '14332', category: 'Lipton' },
  { id: '58773', name: 'SIERRA MIST RS', size: '2LTR 6PK', code: '58773', category: 'Sierra Mist' },
  { id: '58774', name: 'S.MIST ZERO', size: '2LTR 6PK', code: '58774', category: 'Sierra Mist' },
  { id: '55289', name: 'CRUSH ORANGE', size: '2LTR 6PK', code: '55289', category: 'Crush' },
  { id: '55291', name: 'CRUSH DT ORANGE', size: '2LTR 6PK', code: '55291', category: 'Crush' },
  { id: '55294', name: 'CRUSH STRAWBERRY', size: '2LTR 6PK', code: '55294', category: 'Crush' },
  { id: '55515', name: 'CRUSH PINEAPPLE', size: '2LTR 6PK', code: '55515', category: 'Crush' },
  { id: '57820', name: 'CRUSH GRAPE', size: '2LTR 6PK', code: '57820', category: 'Crush' },
  { id: '60825', name: 'CRUSH FRT PUNCH', size: '2LTR 6PK', code: '60825', category: 'Crush' },
  { id: '60675', name: 'PEPSI MANGO', size: '2LTR 6PK', code: '60675', category: 'Pepsi Products' },
  { id: '60679', name: 'PEP ZERO MANGO', size: '2LTR 6PK', code: '60679', category: 'Pepsi Products' },
  { id: '60637', name: 'MANZANITA SOLE', size: '2LTR 6PK', code: '60637', category: 'Other' },
  { id: '60730', name: 'DOLE LEMONADE', size: '2LTR 6PK', code: '60730', category: 'Dole' },
  { id: '60830', name: 'JUCY FRT PUNCH', size: '2LTR 6PK', code: '60830', category: 'Other' },
  { id: '60966', name: 'DOLE TROP LEMONADE', size: '2LTR 6PK', code: '60966', category: 'Dole' },
  { id: '60963', name: 'DOLE STRAW LEMONADE', size: '2LTR 6PK', code: '60963', category: 'Dole' },
  { id: '60009', name: 'CT LEMONADE', size: '2LTR 6PK', code: '60009', category: 'Country Time' },
  { id: '60010', name: 'CT STRAW LMNADE', size: '2LTR 6PK', code: '60010', category: 'Country Time' },
  { id: '56670', name: 'DB CREAM', size: '2LTR 6PK', code: '56670', category: 'Dr Browns' },
  { id: '56669', name: 'DB DT CREAM', size: '2LTR 6PK', code: '56669', category: 'Dr Browns' },
  { id: '56672', name: 'DB CHERRY', size: '2LTR 6PK', code: '56672', category: 'Dr Browns' },
  { id: '56671', name: 'DB DT CHERRY', size: '2LTR 6PK', code: '56671', category: 'Dr Browns' },
  { id: '56668', name: 'DB RT BEER', size: '2LTR 6PK', code: '56668', category: 'Dr Browns' },
  { id: '60876', name: 'DB DT RT BEER', size: '2LTR 6PK', code: '60876', category: 'Dr Browns' },
  
  // 1.25 LITER
  { id: '58716', name: 'PEPSI', size: '1.25LTR 12PK', code: '58716', category: 'Pepsi Products' },
  { id: '58717', name: 'DT PEPSI', size: '1.25LTR 12PK', code: '58717', category: 'Pepsi Products' },
  { id: '58720', name: 'SCH GIN/ALE', size: '1.25LTR 12PK', code: '58720', category: 'Schweppes' },
  { id: '58719', name: 'MT.DEW', size: '1.25LTR 12PK', code: '58719', category: 'Mountain Dew' },
  { id: '60411', name: 'PEPSI ZERO', size: '1.25LTR 12PK', code: '60411', category: 'Pepsi Products' },
  { id: '58718', name: 'CHERRY PEPSI', size: '1.25LTR 12PK', code: '58718', category: 'Pepsi Products' },
  { id: '58721', name: 'CRUSH ORANGE', size: '1.25LTR 12PK', code: '58721', category: 'Crush' },
  { id: '60412', name: 'LTN BRISK', size: '1.25LTR 12PK', code: '60412', category: 'Lipton' },
  { id: '60674', name: 'PEPSI MANGO', size: '1.25LTR 12PK', code: '60674', category: 'Pepsi Products' },
  { id: '60818', name: 'CRUSH GRAPE', size: '1.25LTR 12PK', code: '60818', category: 'Crush' },
  
  // 1 LITER
  { id: '14050', name: 'SCH GINGER ALE', size: '1LTR 12PK', code: '14050', category: 'Schweppes' },
  { id: '14052', name: 'SCH TONIC', size: '1LTR 12PK', code: '14052', category: 'Schweppes' },
  { id: '14053', name: 'SCH CLUB', size: '1LTR 12PK', code: '14053', category: 'Schweppes' },
  { id: '14055', name: 'SCH SELTZER', size: '1LTR 12PK', code: '14055', category: 'Schweppes' },
  { id: '14057', name: 'SCH LL SELT', size: '1LTR 12PK', code: '14057', category: 'Schweppes' },
  { id: '14102', name: 'PEPSI', size: '1LTR 12PK', code: '14102', category: 'Pepsi Products' },
  { id: '14103', name: 'DT PEPSI', size: '1LTR 12PK', code: '14103', category: 'Pepsi Products' },
  { id: '14108', name: 'LIPT BRISK', size: '1LTR 12PK', code: '14108', category: 'Lipton' },
  { id: '57933', name: 'SCH RASP LIME SEL', size: '1LTR 12PK', code: '57933', category: 'Schweppes' },
  { id: '57167', name: 'SCH CHERRY SELT', size: '1LTR 12PK', code: '57167', category: 'Schweppes' },
  { id: '57546', name: 'SCH ORANGE SELT', size: '1LTR 12PK', code: '57546', category: 'Schweppes' },
  { id: '59579', name: 'SCH STRAW MANGO', size: '1LTR 12PK', code: '59579', category: 'Schweppes' },
  
  // LIPTON TEA 1LTR 15PK
  { id: '57944', name: 'LIPT BSK RASPBERRY', size: '1LTR 15PK', code: '57944', category: 'Lipton' },
  { id: '57943', name: 'LIPT BSK STR MELON', size: '1LTR 15PK', code: '57943', category: 'Lipton' },
  { id: '57941', name: 'LIPT BSK TEA LEMADE', size: '1LTR 15PK', code: '57941', category: 'Lipton' },
  { id: '60294', name: 'LTN BLKBERRY SMSH', size: '1LTR 15PK', code: '60294', category: 'Lipton' },
  { id: '60694', name: 'LTN BSK ZRO LEM TEA', size: '1LTR 15PK', code: '60694', category: 'Lipton' },
  
  // LIPTON TEA 18.5Z
  { id: '57119', name: 'LTPL XTRA SWT TEA', size: '18.5Z 12PK', code: '57119', category: 'Lipton' },
  { id: '57055', name: 'LIPT PL T SWT LEM', size: '18.5Z 12PK', code: '57055', category: 'Lipton' },
  { id: '57057', name: 'LIPT PL UNSWEET', size: '18.5Z 12PK', code: '57057', category: 'Lipton' },
  { id: '57058', name: 'LIPT PL PEACH TEA', size: '18.5Z 12PK', code: '57058', category: 'Lipton' },
  { id: '57059', name: 'LIPT PL RASP TEA', size: '18.5Z 12PK', code: '57059', category: 'Lipton' },
  { id: '57060', name: 'LIPT PL DT TEA LEM', size: '18.5Z 12PK', code: '57060', category: 'Lipton' },
  { id: '57244', name: 'LIPT PL SWEET TEA', size: '18.5Z 12PK', code: '57244', category: 'Lipton' },
  { id: '58079', name: 'LIPT PL TEA LMADE', size: '18.5Z 12PK', code: '58079', category: 'Lipton' },
  { id: '60618', name: 'LTNPL GREEN TEA', size: '18.5Z 12PK', code: '60618', category: 'Lipton' },
  { id: '61067', name: 'LTN SUB SWT TEA', size: '18.5Z 12PK', code: '61067', category: 'Lipton' },
  { id: '61068', name: 'LTN SUB SWT PEACH', size: '18.5Z 12PK', code: '61068', category: 'Lipton' },
  { id: '61069', name: 'LTN SUB SWT LEM', size: '18.5Z 12PK', code: '61069', category: 'Lipton' },
  
  // LIPTON TEA 64Z
  { id: '60713', name: 'LTN SWEET TEA', size: '64Z 8PK', code: '60713', category: 'Lipton' },
  { id: '60714', name: 'LTN GREEN TEA CITRUS', size: '64Z 8PK', code: '60714', category: 'Lipton' },
  { id: '60715', name: 'LTN PEACH TEA', size: '64Z 8PK', code: '60715', category: 'Lipton' },
  { id: '60716', name: 'LTN DT GRN CITRUS', size: '64Z 8PK', code: '60716', category: 'Lipton' },
  { id: '58572', name: 'LTNPL SWT NO LEMON', size: '64Z 8PK', code: '58572', category: 'Lipton' },
  { id: '58573', name: 'LTNPL SWEET LEMON', size: '64Z 8PK', code: '58573', category: 'Lipton' },
  { id: '58574', name: 'LTNPL UNSWEET', size: '64Z 8PK', code: '58574', category: 'Lipton' },
  { id: '59206', name: 'LTNPL RASPBERRY', size: '64Z 8PK', code: '59206', category: 'Lipton' },
  
  // LIPTON TEA 16.9Z
  { id: '15609', name: 'LTN SWT LEMON', size: '16.9Z 2/12PK', code: '15609', category: 'Lipton' },
  { id: '15611', name: 'LTN GRN TEA CIT.', size: '16.9Z 2/12PK', code: '15611', category: 'Lipton' },
  { id: '15642', name: 'LTN DT GREEN TEA', size: '16.9Z 2/12PK', code: '15642', category: 'Lipton' },
  { id: '16219', name: 'LTN DT GRN CITRUS', size: '16.9Z 24PK', code: '16219', category: 'Lipton' },
  { id: '15979', name: 'LTN TEA&LEMADE', size: '16.9Z 2/12PK', code: '55979', category: 'Lipton' },
  { id: '59855', name: 'LTNPL SWT W/LEMON', size: '16.9Z 2/6PK', code: '59855', category: 'Lipton' },
  { id: '59857', name: 'LTNPL UNSWEET', size: '16.9Z 2/6PK', code: '59857', category: 'Lipton' },
  { id: '59859', name: 'LTNPL PEACH', size: '16.9Z 2/6PK', code: '59859', category: 'Lipton' },
  
  // BUBLY
  { id: '59458', name: 'BB CHERRY WTR', size: '12Z 3/8PK', code: '59458', category: 'Bubly' },
  { id: '59737', name: 'BB BLKBERRY WTR', size: '12Z 3/8PK', code: '59737', category: 'Bubly' },
  { id: '59808', name: 'BB CRANBERRY WTR', size: '12Z 3/8PK', code: '59808', category: 'Bubly' },
  { id: '59810', name: 'BB RASPBERRY WTR', size: '12Z 3/8PK', code: '59810', category: 'Bubly' },
  { id: '59453', name: 'BB LIME WTR', size: '12Z 3/8PK', code: '59453', category: 'Bubly' },
  { id: '59454', name: 'BB GRAPEFRT WTR', size: '12Z 3/8PK', code: '59454', category: 'Bubly' },
  { id: '59455', name: 'BB STRWBRY WTR', size: '12Z 3/8PK', code: '59455', category: 'Bubly' },
  { id: '59861', name: 'BB WATERMELON WTR', size: '12Z 3/8PK', code: '59861', category: 'Bubly' },
  { id: '59862', name: 'BB PINEAPPLE WTR', size: '12Z 3/8PK', code: '59862', category: 'Bubly' },
  { id: '60276', name: 'BB BLUBRY POM', size: '12Z 3/8PK', code: '60276', category: 'Bubly' },
  { id: '60277', name: 'BB WHT PEACH GIN', size: '12Z 3/8PK', code: '60277', category: 'Bubly' },
  { id: '60194', name: 'BB STRAWBERRY', size: '16Z 12PK', code: '60194', category: 'Bubly' },
  { id: '60491', name: 'BB BNC MANGO PASS', size: '12Z 3/8PK', code: '60491', category: 'Bubly' },
  { id: '60492', name: 'BB ORG GRPFRT', size: '12Z 3/8PK', code: '60492', category: 'Bubly' },
  { id: '60493', name: 'BB TRIPLE BERRY', size: '12Z 3/8PK', code: '60493', category: 'Bubly' },
  
  // ROCKSTAR
  { id: '60477', name: 'RS ORIGINAL', size: '16Z 12PK', code: '60477', category: 'Rockstar' },
  { id: '60478', name: 'RS SUGAR FREE', size: '16Z 12PK', code: '60478', category: 'Rockstar' },
  { id: '60479', name: 'RS PUNCHED', size: '16Z 12PK', code: '60479', category: 'Rockstar' },
  { id: '60549', name: 'RS SILVER ICE', size: '16Z 12PK', code: '60549', category: 'Rockstar' },
  
  // MOUNTAIN DEW ENERGY & KICKSTART
  { id: '60625', name: 'MTD ENERGY TROP.SUN', size: '16Z 12PK', code: '60625', category: 'Mountain Dew' },
  { id: '60626', name: 'MTD ENERGY ORANGE', size: '16Z 12PK', code: '60626', category: 'Mountain Dew' },
  { id: '60627', name: 'MTD ENERGY STRW.MELON', size: '16Z 12PK', code: '60627', category: 'Mountain Dew' },
  { id: '60628', name: 'MTD ENERGY POM.BURST', size: '16Z 12PK', code: '60628', category: 'Mountain Dew' },
  { id: '57583', name: 'MTD KS ORANGE', size: '16Z 12PK', code: '57583', category: 'Mountain Dew' },
  { id: '57584', name: 'MTD KS PUNCH', size: '16Z 12PK', code: '57584', category: 'Mountain Dew' },
  { id: '58756', name: 'MTD KS GRAPE', size: '16Z 12PK', code: '58756', category: 'Mountain Dew' },
  
  // SPECIALTY PRODUCTS
  { id: '60630', name: 'EVOLVE VANILLA', size: '330ML 12PK', code: '60630', category: 'Evolve' },
  { id: '60631', name: 'EVOLVE DBL CHOC', size: '330ML 12PK', code: '60631', category: 'Evolve' },
  { id: '60169', name: 'TREO STRAWBERRY', size: '16Z 12PK', code: '60169', category: 'Treo' },
  { id: '60170', name: 'TREO BLUEBERRY', size: '16Z 12PK', code: '60170', category: 'Treo' },
  { id: '60171', name: 'TREO PEACH MANGO', size: '16Z 12PK', code: '60171', category: 'Treo' },
  { id: '60172', name: 'TREO RASP LEMONADE', size: '16Z 12PK', code: '60172', category: 'Treo' },
  { id: '60414', name: 'TREO KIWI WTRMLN', size: '16Z 12PK', code: '60414', category: 'Treo' },
  
  // DOLE JUICES
  { id: '55832', name: 'DOLE APPLE JUICE', size: '15.2Z 12PK', code: '55832', category: 'Dole' },
  { id: '55831', name: 'DOLE ORANGE JUICE', size: '15.2Z 12PK', code: '55831', category: 'Dole' },
  { id: '60494', name: 'DOLE FRT PUNCH', size: '15.2Z 12PK', code: '60494', category: 'Dole' },
  
  // ORANGINA
  { id: '60284', name: 'ORANGINA', size: '11.2Z 6PK', code: '60284', category: 'Orangina' },
  { id: '60285', name: 'ORANGINA', size: '14.2Z 12PK', code: '60285', category: 'Orangina' },
  { id: '60286', name: 'ORANGINA', size: '8.5Z 12PK', code: '60286', category: 'Orangina' },
  
  // GOOD 2 GROW
  { id: '59838', name: 'G2G FRT PUNCH', size: '6Z 12PK', code: '59838', category: 'Good 2 Grow' },
  { id: '59840', name: 'G2G FRT FUSION', size: '6Z 12PK', code: '59840', category: 'Good 2 Grow' },
  { id: '59841', name: 'G2G GRAPE', size: '6Z 12PK', code: '59841', category: 'Good 2 Grow' },
  { id: '59842', name: 'G2G STRAW KIWI', size: '6Z 12PK', code: '59842', category: 'Good 2 Grow' },
  { id: '59843', name: 'G2G TROP FRUIT MEDLEY', size: '6Z 12PK', code: '59843', category: 'Good 2 Grow' },
  { id: '59839', name: 'G2G APPLE', size: '6Z 12PK', code: '59839', category: 'Good 2 Grow' },
  { id: '59867', name: 'G2G ORG MANGO', size: '10Z 12PK', code: '59867', category: 'Good 2 Grow' },
  { id: '59868', name: 'G2G RASP LMADE', size: '10Z 12PK', code: '59868', category: 'Good 2 Grow' },
  
  // LEAN BODY & PROTEIN
  { id: '60990', name: 'LB SLT CARAMEL', size: '16.9Z 12PK', code: '60990', category: 'Lean Body' },
  { id: '60991', name: 'LB CHOCOLATE', size: '16.9Z 12PK', code: '60991', category: 'Lean Body' },
  { id: '60992', name: 'LB COOKIES&CREAM', size: '16.9Z 12PK', code: '60992', category: 'Lean Body' },
  { id: '60993', name: 'LB VANILLA', size: '16.9Z 12PK', code: '60993', category: 'Lean Body' },
  { id: '60994', name: 'LB STRAWBERRY', size: '16.9Z 12PK', code: '60994', category: 'Lean Body' },
  
  // KOE KOMBUCHA
  { id: '60773', name: 'KOE BLBRY GINGER', size: '12Z 12PK', code: '60773', category: 'Koe' },
  { id: '60774', name: 'KOE MANGO', size: '12Z 12PK', code: '60774', category: 'Koe' },
  { id: '60776', name: 'KOE STRBRY LMADE', size: '12Z 12PK', code: '60776', category: 'Koe' },
  { id: '60778', name: 'KOE TROPICAL', size: '12Z 12PK', code: '60778', category: 'Koe' },
  { id: '60779', name: 'KOE WATERMELON', size: '12Z 12PK', code: '60779', category: 'Koe' },
  
  // AMINO ENERGY
  { id: '60642', name: 'AMINO STRAWBERRY', size: '12Z 12PK', code: '60642', category: 'Amino' },
  { id: '60643', name: 'AMINO PNAPL MANGO', size: '12Z 12PK', code: '60643', category: 'Amino' },
  { id: '60644', name: 'AMINO BLUBRY LMND', size: '12Z 12PK', code: '60644', category: 'Amino' },
  { id: '60645', name: 'AMINO GRAPE', size: '12Z 12PK', code: '60645', category: 'Amino' },
  
  // GFUEL
  { id: '60907', name: 'GFUEL FAZEBERRY', size: '16Z 12PK', code: '60907', category: 'GFuel' },
  { id: '60908', name: 'GFUEL PEWDIEPIE', size: '16Z 12PK', code: '60908', category: 'GFuel' },
  { id: '60909', name: 'GFUEL SONICPEACH', size: '16Z 12PK', code: '60909', category: 'GFuel' },
  { id: '60911', name: 'GFUEL BLUECHUGRUG', size: '16Z 12PK', code: '60911', category: 'GFuel' },
  { id: '60912', name: 'GFUEL SHERBERT', size: '16Z 12PK', code: '60912', category: 'GFuel' },
  { id: '60929', name: 'GFUEL TETRIS ZERO', size: '16Z 12PK', code: '60929', category: 'GFuel' },
  { id: '60945', name: 'GFUEL SPIDERMAN', size: '16Z 12PK', code: '60945', category: 'GFuel' },
  
  // YERBAE
  { id: '60396', name: 'YERBAE CHRPNAPPLE', size: '16Z 12PK', code: '60396', category: 'Yerbae' },
  { id: '60397', name: 'YERBAE TRPL BERRY', size: '16Z 12PK', code: '60397', category: 'Yerbae' },
  { id: '60398', name: 'YERBAE MANGO PASS', size: '16Z 12PK', code: '60398', category: 'Yerbae' },
  { id: '60399', name: 'YERBAE WTRMLN STR', size: '16Z 12PK', code: '60399', category: 'Yerbae' },
  
  // BOLT
  { id: '60274', name: 'BOLT STRW LEMON', size: '16.9Z 12PK', code: '60274', category: 'Bolt' },
  { id: '60275', name: 'BOLT CHERRY LIME', size: '16.9Z 12PK', code: '60275', category: 'Bolt' },
  { id: '60035', name: 'BOLT STRAW WTRMELON', size: '16.9Z 12PK', code: '60035', category: 'Bolt' },
  
  // ALO
  { id: '60864', name: 'ALO ORIGINAL HONEY', size: '16.9Z 12PK', code: '60864', category: 'Alo' },
  { id: '60865', name: 'ALO MANGO', size: '16.9Z 12PK', code: '60865', category: 'Alo' },
  { id: '60866', name: 'ALO WMELON PEACH', size: '16.9Z 12PK', code: '60866', category: 'Alo' },
  { id: '60867', name: 'ALO APPLE PEAR', size: '16.9Z 12PK', code: '60867', category: 'Alo' },
  
  // POLAR SELTZER
  { id: '59541', name: 'PO LEMON SELTZER', size: '2L 8PK', code: '59541', category: 'Polar' },
  { id: '60108', name: 'PO RASPBERRY LIME SELT', size: '2L 8PK', code: '60108', category: 'Polar' },
  { id: '60107', name: 'PO RUBY RED GRPFRT SELT', size: '2L 8PK', code: '60107', category: 'Polar' },
  { id: '60109', name: 'PO CRANBERRY LIME SELT', size: '2L 8PK', code: '60109', category: 'Polar' },
  { id: '59540', name: 'PO LIME SELTZER', size: '2L 8PK', code: '59540', category: 'Polar' },
  { id: '59539', name: 'PO SELTZER', size: '2L 8PK', code: '59539', category: 'Polar' },
  { id: '59489', name: 'PO LEMON SELT.', size: '1L 12PK', code: '59489', category: 'Polar' },
  { id: '59490', name: 'PO BLK CHRY SELT.', size: '1L 12PK', code: '59490', category: 'Polar' },
  { id: '59491', name: 'PO STRW WTRMELON', size: '1L 12PK', code: '59491', category: 'Polar' },
  { id: '59492', name: 'PO RASP LIME SELT.', size: '1L 12PK', code: '59492', category: 'Polar' },
  { id: '59549', name: 'PO RR GRPFT SELT', size: '1L 12PK', code: '59549', category: 'Polar' },
  { id: '59550', name: 'PO BLBRY LEMONADE SELT', size: '1L 12PK', code: '59550', category: 'Polar' },
  { id: '59551', name: 'PO CRAN LIME SELT', size: '1L 12PK', code: '59551', category: 'Polar' },
  { id: '59552', name: 'PO LIME SELTZER', size: '1L 12PK', code: '59552', category: 'Polar' },
  { id: '59553', name: 'PO VANILLA SELT', size: '1L 12PK', code: '59553', category: 'Polar' },
  { id: '59554', name: 'PO ORANGE VAN SELT', size: '1L 12PK', code: '59554', category: 'Polar' },
  { id: '59555', name: 'PO SELTZER', size: '1L 12PK', code: '59555', category: 'Polar' },
  { id: '60976', name: 'PO MERMAID SELT.', size: '7.5Z 6PK', code: '60976', category: 'Polar' },
  { id: '60977', name: 'PO DRAGON SELT.', size: '7.5Z 6PK', code: '60977', category: 'Polar' },
  { id: '60978', name: 'PO UNICORN SELT.', size: '7.5Z 6PK', code: '60978', category: 'Polar' },
  { id: '60979', name: 'PO YETI SELT.', size: '7.5Z 6PK', code: '60979', category: 'Polar' },
  { id: '61031', name: 'PO PIXIE LIGHT SELT.', size: '7.5Z 6PK', code: '61031', category: 'Polar' },
  { id: '61032', name: 'PO WEREWOLF SELT.', size: '7.5Z 6PK', code: '61032', category: 'Polar' },
  
  // 12 PACK CANS - PEPSI FAMILY
  { id: '15543', name: 'PEPSI', size: '12Z 12PK', code: '15543', category: 'Pepsi Products' },
  { id: '15525', name: 'DT PEPSI', size: '12Z 12PK', code: '15525', category: 'Pepsi Products' },
  { id: '15513', name: 'CAF FREE PEPSI', size: '12Z 12PK', code: '15513', category: 'Pepsi Products' },
  { id: '15515', name: 'DT C F PEPSI', size: '12Z 12PK', code: '15515', category: 'Pepsi Products' },
  { id: '15553', name: 'CHERRY PEPSI', size: '12Z 12PK', code: '15553', category: 'Pepsi Products' },
  { id: '15534', name: 'MT DEW', size: '12Z 12PK', code: '15534', category: 'Mountain Dew' },
  { id: '15519', name: 'DT MT DEW', size: '12Z 12PK', code: '15519', category: 'Mountain Dew' },
  { id: '56837', name: 'PEPSI ZERO', size: '12Z 12PK', code: '56837', category: 'Pepsi Products' },
  { id: '15533', name: 'LIPT BRISK', size: '12Z 12PK', code: '15533', category: 'Lipton' },
  { id: '15559', name: 'SCH GINGER ALE', size: '12Z 12PK', code: '15559', category: 'Schweppes' },
  { id: '15539', name: 'MUG ROOT BEER', size: '12Z 12PK', code: '15539', category: 'Mug' },
  { id: '15626', name: 'SCH DT GINGER', size: '12Z 12PK', code: '15626', category: 'Schweppes' },
  { id: '14699', name: 'SCH SELTZER', size: '12Z 12PK', code: '14699', category: 'Schweppes' },
  { id: '15531', name: 'DT CHY PEPSI', size: '12Z 12PK', code: '15531', category: 'Pepsi Products' },
  { id: '57541', name: 'SCH L/L SELT', size: '12Z 12PK', code: '57541', category: 'Schweppes' },
  { id: '57542', name: 'SCH CHY SELT', size: '12Z 12PK', code: '57542', category: 'Schweppes' },
  { id: '57543', name: 'SCH ORG SELT', size: '12Z 12PK', code: '57543', category: 'Schweppes' },
  { id: '57937', name: 'SCH RAS LIME S', size: '12Z 12PK', code: '57937', category: 'Schweppes' },
  { id: '57822', name: 'CRUSH GRAPE', size: '12Z 12PK', code: '57822', category: 'Crush' },
  { id: '15662', name: 'PA D BCH BE', size: '12Z 12PK', code: '15662', category: 'Other' },
  { id: '56772', name: 'DT PA D BCH B', size: '12Z 12PK', code: '56772', category: 'Other' },
  { id: '58366', name: 'SCH POM SELT', size: '12Z 12PK', code: '58366', category: 'Schweppes' },
  { id: '58583', name: 'SCH CRN LIM SEL', size: '12Z 12PK', code: '58583', category: 'Schweppes' },
  { id: '58770', name: 'S.MIST RS', size: '12Z 12PK', code: '58770', category: 'Sierra Mist' },
  { id: '58771', name: 'S MIST ZERO', size: '12Z 12PK', code: '58771', category: 'Sierra Mist' },
  { id: '59262', name: 'SCH GRPFRT', size: '12Z 12PK', code: '59262', category: 'Schweppes' },
  { id: '59577', name: 'SCH STR MANGO', size: '12Z 12PK', code: '59577', category: 'Schweppes' },
  { id: '59707', name: 'PEPSI VANILLA', size: '12Z 12PK', code: '59707', category: 'Pepsi Products' },
  { id: '56828', name: 'CRUSH DT ORG', size: '12Z 12PK', code: '56828', category: 'Crush' },
  { id: '56829', name: 'CRUSH ORANGE', size: '12Z 12PK', code: '56829', category: 'Crush' },
  { id: '60672', name: 'PEPSI MANGO', size: '12Z 12PK', code: '60672', category: 'Pepsi Products' },
  { id: '60676', name: 'PEP ZERO MANGO', size: '12Z 12PK', code: '60676', category: 'Pepsi Products' },
  { id: '60729', name: 'SCH GRAPE SELT.', size: '12Z 12PK', code: '60729', category: 'Schweppes' },
  { id: '60915', name: 'MTD SPARK', size: '12Z 12PK', code: '60915', category: 'Mountain Dew' },
  { id: '60916', name: 'MTD SPARK ZERO', size: '12Z 12PK', code: '60916', category: 'Mountain Dew' },
  { id: '61053', name: 'MTD FLAMIN CITRUS', size: '12Z 12PK', code: '61053', category: 'Mountain Dew' },
  { id: '61107', name: 'MTD BAJA MANGO', size: '12Z 12PK', code: '61107', category: 'Mountain Dew' },
  { id: '60007', name: 'CT LEMONADE', size: '12Z 12PK', code: '60007', category: 'Country Time' },
  { id: '60008', name: 'CT STRAW LMNDE', size: '12Z 12PK', code: '60008', category: 'Country Time' },
  { id: '60334', name: 'DOLE LEMONADE', size: '12Z 12PK', code: '60334', category: 'Dole' },
  { id: '60965', name: 'DOLE STRAW LEMADE', size: '12Z 12PK', code: '60965', category: 'Dole' },
  { id: '60968', name: 'DOLE TROP LEMONAD', size: '12Z 12PK', code: '60968', category: 'Dole' },
  { id: '60828', name: 'JUCY FRT PUNCH', size: '12Z 12PK', code: '60828', category: 'Other' },
  
  // DR BROWNS 12Z 6PK
  { id: '14539', name: 'DB DT CREAM', size: '12Z 6PK', code: '14539', category: 'Dr Browns' },
  { id: '14540', name: 'DB DT CHERRY', size: '12Z 6PK', code: '14540', category: 'Dr Browns' },
  { id: '14541', name: 'DB CREAM', size: '12Z 6PK', code: '14541', category: 'Dr Browns' },
  { id: '14544', name: 'DB CHERRY', size: '12Z 6PK', code: '14544', category: 'Dr Browns' },
  { id: '14546', name: 'DB RT BEER', size: '12Z 6PK', code: '14546', category: 'Dr Browns' },
  { id: '14547', name: 'DB CEL-RAY', size: '12Z 6PK', code: '14547', category: 'Dr Browns' },
  { id: '60875', name: 'DB DT RT BEER', size: '12Z 6PK', code: '60875', category: 'Dr Browns' },
  
  // 16.9Z 4/6PK
  { id: '55192', name: 'PEPSI', size: '16.9Z 6PK', code: '55192', category: 'Pepsi Products' },
  { id: '55193', name: 'DIET PEPSI', size: '16.9Z 6PK', code: '55193', category: 'Pepsi Products' },
  { id: '58196', name: 'CHERRY PEPSI', size: '16.9Z 6PK', code: '58196', category: 'Pepsi Products' },
  { id: '59452', name: 'PEPSI ZERO', size: '16.9Z 6PK', code: '59452', category: 'Pepsi Products' },
  { id: '57814', name: 'SCH GINGER ALE', size: '16.9Z 6PK', code: '57814', category: 'Schweppes' },
  { id: '55993', name: 'CRUSH ORANGE', size: '16.9Z 6PK', code: '55993', category: 'Crush' },
  { id: '59204', name: 'LTN BSK LMN', size: '16.9Z 6PK', code: '59204', category: 'Lipton' },
  { id: '60110', name: 'PO LIME SELT', size: '16.9Z 6PK', code: '60110', category: 'Polar' },
  { id: '60111', name: 'PO LEMON SELT', size: '16.9Z 6PK', code: '60111', category: 'Polar' },
  { id: '60112', name: 'PO RASP LIME SELT', size: '16.9Z 6PK', code: '60112', category: 'Polar' },
  { id: '60113', name: 'PO SELTZER', size: '16.9Z 6PK', code: '60113', category: 'Polar' },
  
  // 3 LITER
  { id: '14435', name: 'PEPSI', size: '3LTR', code: '14435', category: 'Pepsi Products' },
  { id: '55623', name: 'CRUSH ORANGE', size: '3LTR', code: '55623', category: 'Crush' },
  { id: '55624', name: 'SCH GINGER ALE', size: '3LTR', code: '55624', category: 'Schweppes' },
  { id: '55707', name: 'LIPT BRISK', size: '3LTR', code: '55707', category: 'Lipton' }
];

const Hero = () => {
  const [orderSheetOpen, setOrderSheetOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [cart, setCart] = useState([]);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/Order_Sheet_VIP_CODE.961e835f26733041ffda.pdf';
    link.download = 'WALIC_Order_Sheet.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scrollToBrands = () => {
    const brandsSection = document.getElementById('brands');
    if (brandsSection) {
      brandsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.code.includes(searchTerm) ||
    product.size.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const addToCart = (product) => {
    const existing = cart.find(item => item.id === product.id);
    if (existing) {
      setCart(cart.map(item =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

  const exportCart = () => {
    const orderText = cart.map(item => 
      `${item.code} - ${item.name} (${item.size}) - Qty: ${item.quantity}`
    ).join('\n');
    
    const blob = new Blob([`WALIC BEVERAGES ORDER\n\n${orderText}`], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'My_Order.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <section id="home" className="relative text-white overflow-hidden min-h-screen flex items-center justify-center bg-cover bg-center bg-fixed" style={{ backgroundImage: 'url(/images/companyheader.png)', backgroundAttachment: 'fixed', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        {/* Banner Background Image */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-black/20"></div>
        </div>

        {/* Hero Content */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight whitespace-nowrap">
              WALIC Beverage Distributor
            </h2>
            <p className="text-lg md:text-xl text-gray-300 mb-8">
              Your trusted source for premium beverage brands. Serving the East New York and Canarsie area with quality products and exceptional service.
            </p>
            <div className="flex flex-row gap-4 justify-center">
              <button 
                onClick={() => setOrderSheetOpen(true)}
                className="bg-blue-700 text-white px-8 py-4 rounded-lg hover:bg-blue-800 transition text-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2"
              >
                <Download size={20} />
                Order Sheet
              </button>
              <button 
                onClick={scrollToBrands}
                className="bg-blue-700 text-white px-8 py-4 rounded-lg hover:bg-blue-800 transition text-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                View Our Brands
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Order Sheet Modal */}
      {orderSheetOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b">
              <h2 className="text-2xl font-bold text-gray-800">WALIC Order Sheet</h2>
              <button
                onClick={() => setOrderSheetOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition"
              >
                <X size={24} />
              </button>
            </div>

            {/* Search Bar */}
            <div className="p-6 border-b">
              <div className="flex gap-4">
                <div className="flex-1 relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    placeholder="Search by product name, code, or size..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <button
                  onClick={handleDownload}
                  className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition flex items-center gap-2"
                >
                  <Download size={20} />
                  Download PDF
                </button>
              </div>
            </div>

            {/* Content Area */}
            <div className="flex-1 overflow-hidden flex">
              {/* Products List */}
              <div className="flex-1 overflow-y-auto p-6">
                <h3 className="text-lg font-semibold mb-4 text-gray-700">
                  {filteredProducts.length} Products Found
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {filteredProducts.map((product) => (
                    <div
                      key={product.id}
                      className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition"
                    >
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-800">{product.name}</h4>
                          <p className="text-sm text-gray-600">{product.size}</p>
                          <p className="text-xs text-gray-500 mt-1">Code: {product.code}</p>
                        </div>
                        <button
                          onClick={() => addToCart(product)}
                          className="ml-4 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition text-sm"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                {filteredProducts.length === 0 && (
                  <p className="text-center text-gray-500 mt-8">No products found</p>
                )}
              </div>

              {/* Cart Sidebar */}
              <div className="w-80 border-l bg-gray-50 overflow-y-auto p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                    <ShoppingCart size={20} />
                    My Order ({cart.length})
                  </h3>
                  {cart.length > 0 && (
                    <button
                      onClick={exportCart}
                      className="text-sm px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Export
                    </button>
                  )}
                </div>
                
                {cart.length === 0 ? (
                  <p className="text-center text-gray-500 mt-8">No items added</p>
                ) : (
                  <div className="space-y-3">
                    {cart.map((item) => (
                      <div key={item.id} className="bg-white p-3 rounded-lg border">
                        <div className="flex justify-between items-start">
                          <div className="flex-1">
                            <h4 className="font-medium text-sm">{item.name}</h4>
                            <p className="text-xs text-gray-600">{item.size}</p>
                            <p className="text-xs text-gray-500">Code: {item.code}</p>
                            <p className="text-sm font-semibold mt-1">Qty: {item.quantity}</p>
                          </div>
                          <button
                            onClick={() => removeFromCart(item.id)}
                            className="text-red-500 hover:text-red-700"
                          >
                            <X size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;